import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { Codeword } from '../../../../../models/Codeword';
import { ProtocolService } from '../../../../../services/commons/protocol.service';
import { CodewordChangeRequest } from '../../../../../services/SicorService/RequestObject/CodewordChangeRequest';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { GlobalMethodsService } from '../../../../../services/global-methods.service';
import { DefaultModalComponent } from '../../../default-modal/default-modal.component';

@Component({
  selector: 'app-word-of-duress',
  templateUrl: './word-of-duress.component.html',
  styleUrls: ['./word-of-duress.component.scss'],
})
export class WordOfDuressComponent implements OnInit {

  public wordForm: FormGroup;
  public editForm: boolean = false;
  public title: string;
  public isServiceBusy = false;
  public codeWordType = '';
  @Input() codeWord: Codeword;
  @Input() user: any;
  @Input() s_ins: number;
  @Input() codeWordList: any;

  constructor(private modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private protocolService: ProtocolService,
    private defaultModalComponent: DefaultModalComponent,
    private translate: TranslateConfigService,
    public gms: GlobalMethodsService) { }

  ngOnInit() {
    if (this.codeWord.code === undefined) {
      this.editForm = true;
    }
    this.wordForm = this.formBuilder.group({
      word: new FormControl(this.codeWord.code, [Validators.required])
    });
  }

  async ionViewWillEnter() {
    this.gms.analyticsTrackEvent('openScreen', { screenName: 'Palabra Clave', contentGroup: 'Protocolo' });
    switch (this.codeWord.tp) {
      case "CRA":
        this.title = await this.translate.getTranslate('PROTOCOL.tabKeywords.keyword1.wordOfDuress');
        this.codeWordType = 'Llamada';
        break;
      case "CLI":
        this.title = await this.translate.getTranslate('PROTOCOL.tabKeywords.keyword2.wordOfDuress');
        this.codeWordType = 'Segura';
        break;
      case "COA":
        this.title = await this.translate.getTranslate('PROTOCOL.tabKeywords.keyword3.wordOfDuress');
        this.codeWordType = 'No Segura';
        break;
    }
  }

  async ngAfterViewInit() {
    this.gms.closeWordOfDuressComponent.subscribe(async () => {
      this.dismiss(false);
    });
  }

  public async onSubmit() {
    if (this.isServiceBusy) {
      return;
    }
    this.gms.analyticsTrackEvent('keyword_event', { eventCategory: 'SICOR/Palabra Clave', eventAction: 'Accion/Guardar Cambios Click', eventLabel: this.codeWordType });
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      await this.gms.setLoadingTrue();
      this.wordForm = this.gms.checkAllowedCharacters(this.wordForm);
      if (this.wordForm.valid) {
        this.isServiceBusy = true;
        let isRepeated = false;
        this.codeWordList.forEach(codeword => {
          if (codeword.tp != this.codeWord.tp) {
            if (codeword.code == this.wordForm.value.word) {
              isRepeated = true;
            }
          }
        });
        if (!isRepeated) {
          const requestParams = new CodewordChangeRequest(
            this.user, this.s_ins, this.codeWord.tp, this.wordForm.value.word.trim(), this.codeWord.ix, this.codeWord.exp_date
          );
          let result = await this.protocolService.changeInstallationCodewords(requestParams);
          if (result === 0) {
            this.gms.analyticsTrackEvent('keyword_event', { eventCategory: 'SICOR/Palabra Clave', eventAction: 'Accion/Palabra Clave Editar', eventLabel: this.codeWordType });
            this.modalCtrl.dismiss({ result: true }, '', 'wordDuress');
          } else {
            this.gms.analyticsTrackEvent('keyword_event', { eventCategory: 'SICOR/Palabra Clave', eventAction: 'Error/Palabra Clave Editar', eventLabel: this.codeWordType });
            this.modalCtrl.dismiss({ result: false }, '', 'wordDuress');
          }
          this.isServiceBusy = false;
        } else {
          await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.codewordInUse'),
            'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
            this.modalCtrl.dismiss({ result: false }, '', 'wordDuress');
        }
      } else {
        this.gms.analyticsTrackEvent('keyword_event', { eventCategory: 'SICOR/Palabra Clave', eventAction: 'Error/Palabra Clave Editar', eventLabel: this.codeWordType });
        this.validateAllFormFields(this.wordForm);
      }
      await this.gms.setLoadingFalse();
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  isFieldValid(field: string) {
    return !this.wordForm.get(field).valid && this.wordForm.get(field).touched;
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  dismiss(value) {
    this.modalCtrl.dismiss({ result: value });
  }

  clickEdit() {
    this.editForm = !this.editForm;
  }

}
